// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3N5eL","productName":"Table_productName__BiIwE"};